var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"connectToWallet":_vm.connectToWallet}}),_c('div',{staticClass:"content"},[(_vm.isRouterAlive)?_c('router-view',{ref:"routerRef"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }